/* =====================================================================
   PhantomR — search overlay + predictive search (lightweight)
   ===================================================================== */
(function () {
  "use strict";
  var R = (window.PhantomR && window.PhantomR.routes) || {};
  var U = (window.PhantomR && window.PhantomR.utils) || {};

  var modal = document.querySelector("[data-search-modal]");
  if (!modal) return;
  var input = modal.querySelector("[data-predictive-input]");
  var results = modal.querySelector("[data-predictive-results]");
  var releaseFocus = null, lastOpener = null, timer = null, activeIdx = -1;

  function open(opener) {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    if (U.showOverlay) U.showOverlay();
    if (U.lockScroll) U.lockScroll();
    lastOpener = opener || null;
    setTimeout(function () { input.focus(); }, 60);
    releaseFocus = U.trapFocus ? U.trapFocus(modal, lastOpener) : null;
  }
  function close() {
    if (!modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (U.hideOverlay) U.hideOverlay();
    if (U.unlockScroll) U.unlockScroll();
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
  }

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  function sized(url) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=200"; }

  function search(q) {
    if (q.length < 2) { results.innerHTML = ""; activeIdx = -1; return; }
    var url = R.predictiveSearch + "?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection,page&resources[limit]=6";
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(q, (data.resources && data.resources.results) || {}); })
      .catch(function () { results.innerHTML = ""; });
  }

  function render(q, res) {
    var html = "";
    var products = res.products || [];
    if (products.length) {
      html += '<div class="predictive__group"><p class="predictive__heading">' +
        (window.PhantomR.i18n && window.PhantomR.i18n.products || "Products") + '</p><div class="predictive__products">';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || "";
        html += '<a class="predictive__product" data-result href="' + esc(p.url) + '">' +
          '<span class="media ratio-square">' + (img ? '<img src="' + esc(sized(img)) + '" alt="" loading="lazy">' : "") + '</span>' +
          (p.product_type ? '<span class="predictive__product-type">' + esc(p.product_type) + "</span>" : "") +
          '<span class="predictive__product-title">' + esc(p.title) + "</span></a>";
      });
      html += "</div></div>";
    }
    var links = [].concat(res.collections || [], res.pages || []);
    if (links.length) {
      html += '<div class="predictive__group"><div class="predictive__links">';
      links.forEach(function (l) { html += '<a data-result href="' + esc(l.url) + '">' + esc(l.title) + "</a>"; });
      html += "</div></div>";
    }
    if (!products.length && !links.length) {
      html = '<p class="predictive__empty">' + esc("No results yet for “" + q + "”.") + "</p>";
    } else {
      html += '<a class="btn btn--secondary predictive__viewall" data-result href="' + (R.search || "/search") + "?q=" + encodeURIComponent(q) +
        '&type=product">' + (window.PhantomR.i18n && window.PhantomR.i18n.viewAll || "View all results") + "</a>";
    }
    results.innerHTML = html;
    activeIdx = -1;
  }

  /* keyboard nav over results */
  function items() { return Array.prototype.slice.call(results.querySelectorAll("[data-result]")); }
  input && input.addEventListener("keydown", function (e) {
    var list = items();
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      if (!list.length) return;
      e.preventDefault();
      list.forEach(function (el) { el.classList.remove("is-active"); });
      activeIdx = e.key === "ArrowDown" ? (activeIdx + 1) % list.length : (activeIdx - 1 + list.length) % list.length;
      list[activeIdx].classList.add("is-active");
      list[activeIdx].scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter" && activeIdx > -1 && list[activeIdx]) {
      e.preventDefault();
      window.location.href = list[activeIdx].getAttribute("href");
    }
  });

  input && input.addEventListener("input", function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { search(q); }, 250);
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-toggle]")) { e.preventDefault(); open(e.target.closest("[data-search-toggle]")); }
    else if (e.target.closest("[data-search-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("phantomr:dismiss", close);

  window.PhantomR = window.PhantomR || {};
  window.PhantomR.search = { open: open, close: close };
})();
